import { useEffect, useState } from "react";

import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Grid,
} from "@material-ui/core";

import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import HeaderClientes from "components/_refactor/headers/clients";
import ConfigurableCustomerContactMethod from "./components/card-config-contact-method";
import useLogs from "hooks/logs";
import Api from "lib/api/httpRequestHelper";
import { IsMobile, IsMobile900 } from "utils/is-mobile";

export default function ConfiguracoesTemplateOmnichat() {
  const snackbar = useSnackbar();
  const { setLocalStorageApiProblem } = useLogs();

  const isMobile900 = IsMobile900();
  const isMobile = IsMobile();

  const itemXS = 12;

  const [seller, setSeller] = useState("");
  const [sellerList, setSellerList] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [scheduleList, setScheduleList] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [templateOptions, setTemplateOptions] = useState([]);

  const [template, setTemplate] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [variables, setVariables] = useState({});
  const [isSaving, setIsSaving] = useState(false);

  const templateVariableCount =
    selectedTemplate?.text.match(/{{\d+}}/g)?.length || 0;

  const [isFetchingTemplate, setIsFetchingTemplate] = useState(false);
  const [isLoadingSellers, setIsLoadingSellers] = useState(false);
  const [isLoadingStores, setIsLoadingStores] = useState(false);
  const [isLoadingSchedules, setIsLoadingSchedules] = useState(false);
  const [isLoadingTemplates, setIsLoadingTemplates] = useState(false);

  const handleGetStoreList = async () => {
    setIsLoadingStores(true);

    await Api.get("store", "commercialstructure", "?idMarca=1", true)
      .then((res) => {
        if (res?.Success) {
          setStoreList(res?.Result);
        }
      })
      .catch((error) => {
        console.log(error);
        setLocalStorageApiProblem({
          idMenuAccess: "156",
          screen: "ConfiguracoesTemplateOmnichat",
          problem: `Erro na chamada do endpoint store - ${error}`,
        });
      })
      .finally(() => setIsLoadingStores(false));
  };

  const handleGetSellerList = async () => {
    setIsLoadingSellers(true);

    await Api.get(
      "seller-list",
      "action",
      `?IdPessoaLoja=${selectedStore?.Id?.toString()}`,
      true
    )
      .then((resp) => {
        if (resp?.Success) {
          if (resp?.Result?.ListaVendedores?.length === 0) {
            snackbar.showMessage(
              "Nenhum vendedor localizado. Faça a busca novamente",
              {
                severity: "success",
              }
            );
          } else {
            setSellerList(resp?.Result?.ListaVendedores);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "156",
          screen: "ConfiguracoesTemplateOmnichat",
          problem: `Erro na chamada do endpoint seller-list - ${error}`,
        });
      })
      .finally(() => setIsLoadingSellers(false));
  };

  const handleGetScheduleList = async () => {
    setIsLoadingSchedules(true);
    await Api.get(
      "schedule-list",
      "action",
      `?IdPessoaLoja=${selectedStore?.Id?.toString()}&IdVendedor=${
        seller?.IdLojaVendedorAction
      }`,
      true
    )
      .then((resp) => {
        if (resp?.Success) {
          if (resp?.Result?.length === 0) {
            snackbar.showMessage(
              "Nenhuma agenda localizada. Faça a busca novamente",
              {
                severity: "success",
              }
            );
          } else {
            setScheduleList(resp?.Result);
          }
        }
      })
      .catch((error) => {
        console.log(error);
        snackbar.showMessage(error, {
          severity: "error",
        });
        setLocalStorageApiProblem({
          idMenuAccess: "156",
          screen: "ConfiguracoesTemplateOmnichat",
          problem: `Erro na chamada do endpoint schedule-list - ${error}`,
        });
      })
      .finally(() => setIsLoadingSchedules(false));
  };

  const handleUpdateTemplateVariables = async () => {
    try {
      setIsSaving(true);
      if (!template?.IdTemplateAgenda) {
        await Api.post(
          "schedule-template-create",
          "action",
          {
            idTemplate: selectedTemplate.objectId,
            jsonEstrutura: variables,
            idPessoaLoja: selectedStore?.Id,
            idAgenda: selectedSchedule?.Id,
          },
          true
        );
      } else {
        await Api.put(
          "schedule-template-edit",
          "action",
          {
            idTemplateAgenda: template.IdTemplateAgenda,
            idTemplate: selectedTemplate.objectId,
            jsonEstrutura: variables,
          },
          true
        );
      }
      snackbar.showMessage("Template atualizado com sucesso", {
        severity: "success",
      });
      getTemplates();
    } catch (error) {
      console.log(error);
      snackbar.showMessage(
        error?.response?.data?.ErrorMessage ||
          "Não foi possiver salvar configuração",
        {
          severity: "error",
        }
      );
    } finally {
      setIsSaving(false);
    }
  };

  useEffect(() => {
    if (!selectedSchedule) return;

    setSelectedTemplate(null);
    setVariables({});
    const getTemplateForSchedule = async () => {
      setIsFetchingTemplate(true);
      Api.get(
        "schedule-template-detail",
        "action",
        `?idAgenda=${selectedSchedule.Id}&idPessoaLoja=${selectedStore.Id}`,
        true
      )
        .then((res) => {
          if (res?.Result?.length > 0) {
            const template = res.Result[0];
            setTemplate(template);

            setSelectedTemplate(
              templateOptions?.find(
                (item) => item.objectId === template.IdTemplate
              )
            );
            setVariables(JSON.parse(template.JsonEstrutura || "{}"));
          }
        })

        .finally(() => setIsFetchingTemplate(false));
    };

    getTemplateForSchedule();
  }, [selectedSchedule]);

  async function getTemplates() {
    try {
      setIsLoadingTemplates(true);
      const response = await Api.get("get-omni-template", "action", "");

      setTemplateOptions(response.Result.ListaTemplate);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingTemplates(false);
    }
  }

  useEffect(() => {
    getTemplates();
  }, []);

  useEffect(() => {
    handleGetStoreList();
  }, []);

  useEffect(() => {
    if (selectedStore) {
      handleGetSellerList();
    }
  }, [selectedStore]);

  useEffect(() => {
    if (seller) {
      handleGetScheduleList();
    }
  }, [seller]);

  return (
    <>
      <HeaderClientes
        section="Configurações Template Omnichat"
        subsection="Administração"
      />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card>
              <CardHeader
                title="Configurações"
                titleTypographyProps={{
                  component: Box,
                  marginBottom: "0!important",
                  variant: "h3",
                }}
              />
              <CardContent>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={itemXS}>
                    <AutoCompleteField
                      options={storeList}
                      label="Loja"
                      onChange={setSelectedStore}
                      disabled={storeList?.length === 0}
                      loading={isLoadingStores}
                      value={selectedStore}
                      optionLabelKey="Apelido"
                      customTooltipText={(option) => option?.Apelido}
                    />
                  </Grid>

                  <Grid item xs={itemXS}>
                    <AutoCompleteField
                      options={sellerList}
                      label="Vendedor"
                      onChange={setSeller}
                      disabled={!selectedStore}
                      loading={isLoadingSellers}
                      value={seller}
                      optionIdKey="IdLojaVendedorAction"
                    />
                  </Grid>

                  <Grid item xs={itemXS}>
                    <AutoCompleteField
                      options={scheduleList}
                      label="Agenda"
                      onChange={setSelectedSchedule}
                      value={selectedSchedule}
                      loading={isLoadingSchedules}
                      disabled={!seller}
                    />
                  </Grid>

                  <Grid item xs={itemXS}>
                    <AutoCompleteField
                      options={templateOptions}
                      label="Template"
                      value={selectedTemplate}
                      onChange={(value) => {
                        setSelectedTemplate(value);

                        if (value?.objectId === template?.IdTemplate) {
                          setVariables(
                            JSON.parse(template?.JsonEstrutura || "{}")
                          );
                        } else {
                          setVariables({});
                        }
                      }}
                      loading={isLoadingTemplates}
                      optionLabelKey="title"
                      optionIdKey="objectId"
                      disabled={isSaving || !selectedSchedule}
                    />

                    {Array.from({ length: templateVariableCount }).map(
                      (_, index) => {
                        return (
                          <AutoCompleteField
                            key={index}
                            label={`{{${index + 1}}}`}
                            value={{
                              label: variables[index + 1],
                              value: variables[index + 1],
                            }}
                            disabled={isSaving}
                            onChange={(option) => {
                              setVariables((variables) => ({
                                ...variables,
                                [index + 1]: option?.value,
                              }));
                            }}
                            options={[
                              {
                                label: "Nome",
                                value: "Nome",
                              },
                              {
                                label: "NomeCompleto",
                                value: "NomeCompleto",
                              },

                              {
                                label: "CrmBonus",
                                value: "CrmBonus",
                              },
                              {
                                label: "ExpiracaoCrmBonus",
                                value: "ExpiracaoCrmBonus",
                              },
                            ]}
                            optionLabelKey="label"
                            optionIdKey="value"
                          />
                        );
                      }
                    )}
                  </Grid>

                  <Grid item xs={itemXS}>
                    <Button
                      style={
                        isMobile || isMobile900
                          ? {
                              width: "100%",
                              marginBottom: "0.75rem",
                              marginTop: "0.75rem",
                            }
                          : { marginBottom: "0rem" }
                      }
                      variant="contained"
                      disabled={isSaving || isFetchingTemplate}
                      onClick={handleUpdateTemplateVariables}
                    >
                      {isSaving ? "Atualizando..." : "Atualizar"}
                    </Button>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

          <ConfigurableCustomerContactMethod
            title="Link de Pagamento"
            templateOptions={templateOptions}
            type="LK"
            storeList={storeList}
          />
          <ConfigurableCustomerContactMethod
            title="Cliente 360"
            templateOptions={templateOptions}
            type="C360"
            storeList={storeList}
          />
          <ConfigurableCustomerContactMethod
            title="Vitrine Virtual"
            templateOptions={templateOptions}
            type="VITRINE"
            storeList={storeList}
          />
          <ConfigurableCustomerContactMethod
            title="Compartilhamento Nota Fiscal"
            templateOptions={templateOptions}
            type="CNF"
            storeList={storeList}
          />
          <ConfigurableCustomerContactMethod
            title="Template PIX Copia e Cola"
            templateOptions={templateOptions}
            type="PIX"
            storeList={storeList}
          />
        </Grid>
      </Container>
    </>
  );
}
